import React from 'react'

import logo from 'assets/integrations/stripe.png'
import NavigatableIntegrationWidgetCard from '../NavigatableIntegrationWidgetCard'
import StripeDetail from './StripeDetail'
import StripeIndex from './StripeIndex'

export default function StripeView({ data, doHideCard, isLoading }) {
  return (
    <NavigatableIntegrationWidgetCard
      data={data}
      detailComponent={StripeDetail}
      doHideCard={doHideCard}
      image={logo}
      indexComponent={StripeIndex}
      isLoading={isLoading}
      title="Stripe"
      persistenceKey="stripe"
    />
  )
}
